module.exports = __webpack_public_path__ + "img/P150T_weapon_80.e98526b4.png";